import React from 'react'
import PropTypes from 'prop-types'
import MentalHealthAndCommitteesIntro from './MentalHealthAndCommitteesIntro'
import MentalHealthAndCommiteesContent from './MentalHealthAndCommiteesContent'

import './MentalHealthAndCommitteesLayout.scss'

/**
 * MentalHealthAndCommitteesLayout
 * 
 * @param {object} introData 
 * @param {array} contentData
 *
 * @returns {JSX Element}
 */
export default function MentalHealthAndCommitteesLayout({ introData, contentData }) {

  return (
    <section className="mental-committees">
      <div className="mental-committees__wrapper content-wrapper">
        <MentalHealthAndCommitteesIntro introData={introData} />
        {contentData && <MentalHealthAndCommiteesContent contentDataFields={contentData} />}
      </div>
    </section>
  )
}

MentalHealthAndCommitteesLayout.propTypes = {
  introData: PropTypes.object,
  contentData: PropTypes.array
}